import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { DATABASE_REFERENCE_1 } from "../../firebase";
import { set, ref } from "firebase/database";
import { database } from "../../firebase";
import { toast } from "react-toastify";

// import { isReadable } from "stream";
// import { read } from "fs";

const GradesDetails = ({ data }) => {
  const { id } = useParams();
  const idGrade = parseInt(id);
  const [itemTitle, setItemTitle] = useState({});
  const [studentGrouping, setStudentGrouping] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [studentDetail, setStudentDetail] = useState([]);

  useEffect(() => {
    setStudentDetail(data.filter((item) => item.t1key110 === idGrade));
    setFormValues(data.filter((item) => item.t1key110 === idGrade)[0]);
  }, [data]);

  useEffect(() => {
    if (data) {
      setItemTitle(data ? data[0] : null);
      setStudentGrouping(data ? data[1] : null);
    }
  }, [data, studentGrouping]);

  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [name]: value,
    }));
  };

  const handleSaveClick = () => {
    // Update the Firebase database with the new values in formValues
    const databaseRef = ref(database, DATABASE_REFERENCE_1);
    // Loop through formValues and update the Firebase database
    console.log("THE FORM VALUES ARE ", formValues);
    const updatedArray = readjustArray(data, formValues);
    console.log("NOW UPDATING THE VALUES ", updatedArray);
    set(databaseRef, updatedArray);
    setIsEditing(false);
    toast.success("Successfully updated!");
  };

  function readjustArray(array, newItem) {
    const map = new Map();
    array.forEach((obj) => map.set(String(obj.t1key110), obj));
    map.delete(id);
    const newArray = Array.from(map.entries()).map(([_, value]) => value);
    newArray.push(newItem);
    return newArray;
  }

  return (
    <>
      <div className="d-flex flex-column mt-4">
        
        {/* 240314 hide the Edit button not use in this version
        <div>
          {!isEditing ? <button onClick={handleEditClick}>Edit</button> : <></>}
        </div> */}

        <div className="d-flex flex-column">
          {/* t1key110 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1key110 ? `${data[0]?.t1key110}: ` : ""}
                  </strong>
                  <div>
                    {item.t1key110 ? item.t1key110 : formValues?.t1key110}
                  </div>
                </>
              ))}
          </div>
          {/* t1key112 */}
          {/* <div className="d-flex">
            {data &&
              studentGrouping &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1key112 ? `${data[0]?.t1key112}: ` : ""}
                  </strong>
                  {data[1].t1key112.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1key112}
                      name="t1key112"
                      onChange={(e) => handleInputChange(e)}
                      placeholder={`Edit passcode`}
                    ></input>
                  ) : (
                    <div>
                      {item.t1key112 ? item.t1key112 : formValues?.t1key112}
                    </div>
                  )}
                </>
              ))}
          </div> */}
          {/* 120 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item120 &&
              formValues?.t1item120 != "Unavailable" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item120 ? `${data[0]?.t1item120}: ` : ""}
                  </strong>
                  {data[1].t1item120.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item120}
                      name="t1item120"
                      onChange={(e) => handleInputChange(e)}
                      placeholder="Edit name"
                    ></input>
                  ) : (
                    <div>
                      {item.t1item120 ? item.t1item120 : formValues?.t1item120}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 130 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item130 &&
              formValues?.t1item130 != "Unavailable" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item130 ? `${data[0]?.t1item130}: ` : ""}
                  </strong>
                  {data[1].t1item130.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item130}
                      name="t1item130"
                      onChange={(e) => handleInputChange(e)}
                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item.t1item130 ? item.t1item130 : formValues?.t1item130}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 140 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item140 &&
              data[1]?.t1item140 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item140 ? `${data[0]?.t1item140}: ` : ""}
                  </strong>
                  {data[1].t1item140.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item140}
                      name="t1item140"
                      onChange={(e) => handleInputChange(e)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item.t1item140 ? item.t1item140 : formValues?.t1item140}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 150 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item150 &&
              data[1]?.t1item150 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item150 ? `${data[0]?.t1item150}: ` : ""}
                  </strong>
                  {data[1].t1item150.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item150}
                      name="t1item150"
                      onChange={(e) => handleInputChange(e)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item.t1item150 ? item.t1item150 : formValues?.t1item150}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 160 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item160 &&
              data[1]?.t1item160 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item160 ? `${data[0]?.t1item160}: ` : ""}
                  </strong>
                  {data[1].t1item160.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item160}
                      name="t1item160"
                      onChange={(e) => handleInputChange(e)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item.t1item160 ? item.t1item160 : formValues?.t1item160}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 170 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item170 &&
              data[1]?.t1item170 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item170 ? `${data[0]?.t1item170}: ` : ""}
                  </strong>
                  {data[1].t1item170.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item170}
                      name="t1item170"
                      onChange={(e) => handleInputChange(e)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item.t1item170 ? item.t1item170 : formValues?.t1item170}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 180 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item180 &&
              data[1]?.t1item180 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item180 ? `${data[0]?.t1item180}: ` : ""}
                  </strong>
                  {data[1].t1item180.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item180}
                      name="t1item180"
                      onChange={(e) => handleInputChange(e)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item.t1item180 ? item.t1item180 : formValues?.t1item180}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 190 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item190 &&
              data[1]?.t1item190 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item190 ? `${data[0]?.t1item190}: ` : ""}
                  </strong>
                  {data[1].t1item190.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item190}
                      name="t1item190"
                      onChange={(e) => handleInputChange(e)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item.t1item190 ? item.t1item190 : formValues?.t1item190}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 200 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item200 &&
              data[1]?.t1item200 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item200 ? `${data[0]?.t1item200}: ` : ""}
                  </strong>
                  {data[1].t1item200.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item120}
                      name="t1item200"
                      onChange={(e) => handleInputChange(e)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item.t1item200 ? item.t1item200 : formValues?.t1item200}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 210 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item210 &&
              data[1]?.t1item210 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item210 ? `${data[0]?.t1item210}: ` : ""}
                  </strong>
                  {data[1]?.t1item210?.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item210}
                      name="t1item210"
                      onChange={(e) => handleInputChange(e, item?.t1key110)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item?.t1item210
                        ? item?.t1item210
                        : formValues?.t1item210}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 220 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item220 &&
              data[1]?.t1item220 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item220 ? `${data[0]?.t1item220}: ` : ""}
                  </strong>
                  {data[1]?.t1item220?.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item220}
                      name="t1item220"
                      onChange={(e) => handleInputChange(e, item?.t1key110)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item?.t1item220
                        ? item?.t1item220
                        : formValues?.t1item220}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 230 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item230 &&
              data[1]?.t1item230 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item230 ? `${data[0]?.t1item230}: ` : ""}
                  </strong>
                  {data[1].t1item230?.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item230}
                      name="t1item230"
                      onChange={(e) => handleInputChange(e, item?.t1key110)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item?.t1item230
                        ? item?.t1item230
                        : formValues?.t1item230}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 240 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item240 &&
              data[1]?.t1item240 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item240 ? `${data[0]?.t1item240}: ` : ""}
                  </strong>
                  {data[1].t1item240?.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item240}
                      name="t1item240"
                      onChange={(e) => handleInputChange(e, item?.t1key110)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item?.t1item240
                        ? item?.t1item240
                        : formValues?.t1item240}
                    </div>
                  )}
                </>
              ))}
          </div>
          {/* 250 */}
          <div className="d-flex">
            {data &&
              studentGrouping &&
              data[0]?.t1item250 &&
              data[1]?.t1item250 !== "null" &&
              studentDetail.map((item) => (
                <>
                  <strong style={{ minWidth: "110px" }}>
                    {data[0]?.t1item250 ? `${data[0]?.t1item250}: ` : ""}
                  </strong>
                  {data[1]?.t1item250?.includes("editable") && isEditing ? (
                    <input
                      type="text"
                      value={formValues?.t1item250}
                      name="t1item250"
                      onChange={(e) => handleInputChange(e, item?.t1key110)}

                      // placeholder="edit"
                    ></input>
                  ) : (
                    <div>
                      {item?.t1item250
                        ? item?.t1item250
                        : formValues?.t1item250}
                    </div>
                  )}
                </>
              ))}
          </div>
        </div>
        {isEditing && (
          <>
            <button
              style={{
                background: "green",
                color: "#fff",
                width: "100px",
                margin: "5px 100px ",
              }}
              onClick={handleSaveClick}
            >
              Save
            </button>
            <button
              style={{ width: "100px", margin: "5px 100px" }}
              onClick={handleEditClick}
            >
              Cancel
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default GradesDetails;
